<template>
	<div class="app main">
		<div class="main_con">
			<div class="main_top">
				<div class="main_top_left">
					<div class="main_top_left_top">
						<img src="../../../assets/service_center/homeImage/main_top_left.png">
						<div class="main_top_left_top_title">告警数据</div>
						<div class="main_top_left_top_con">
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTypeDataList', 2, '过流异常')">
								<span id="itemImg1" class="main_top_left_c_l_n main_top_left_c_l_n1 counter-value">0</span>
								<p>过流异常</p>
							</div>
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTypeDataList', 2, '过压异常')">
								<span id="itemImg2" class="main_top_left_c_l_n main_top_left_c_l_n2 counter-value">0</span>
								<p>过压异常</p>
							</div>
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTypeDataList', 2, '欠压异常')">
								<span id="itemImg3" class="main_top_left_c_l_n main_top_left_c_l_n3 counter-value">0</span>
								<p>欠压异常</p>
							</div>
							<div class="main_top_left_top_con_left">
								<div class="main_top_left_t_c_l_left" v-on:click="popupClick('getAbTypeDataList', 2, '温度异常')">
									<span id="itemImg4" class="main_top_left_c_l_n main_top_left_c_l_n4 counter-value">0</span>
									<p>温度异常</p>
								</div>
								<div class="main_top_left_t_c_l_right" v-on:click="popupClick('getAbTypeDataList', 2, '漏电异常')">
									<span id="itemImg5" class="main_top_left_c_l_n main_top_left_c_l_n5 counter-value">0</span>
									<p>漏电异常</p>
								</div>
							</div>
							<div class="main_top_left_top_con_right main_top_left_top_con_right2">
								<div class="main_top_left_t_c_r_left" v-on:click="popupClick('getAbTypeDataList', 2, '三相不平衡')">
									<span id="itemImg6" class="main_top_left_c_l_n">0</span>
									<p>三相不平衡</p>
								</div>
								<div class="main_top_left_t_c_r_right" v-on:click="popupClick('getAbTypeDataList', 2, '维护模式')">
									<span id="itemImg7" class="main_top_left_c_l_n">0</span>
									<p>维护模式</p>
								</div>
							</div>
						</div>
					</div>
					<div class="main_top_left_top main_top_left_bottom">
						<img src="../../../assets/service_center/homeImage/main_top_left.png">
						<div class="main_top_left_top_title">设备类型统计</div>
						<div id="baseId" class="main_top_left_top_con" _echarts_instance_="ec_1608255831488" style="-webkit-tap-highlight-color: transparent; user-select: none;">
							<div id="main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
				</div>
				<div class="main_top_middle">
					<div class="main_top_middle_top_title">
						<img class="title_bg" src="../../../assets/service_center/homeImage/title_bg.png">
						{{ TitleName ? TitleName : '智慧用电管理平台'}}
						<div class="title_switch" @click="logout">
							<img src="../../../assets/service_center/homeImage/sign_out.png" />
						</div>
					</div>
					<div class="main_top_middle_num_title">告警数量</div>
					<div class="main_top_middle_num" v-on:click="popupClick('getAbData', 2, '全部告警')">
						<div v-for="(iten, index) in numCounts" :key="index" class="main_top_middle_num_list">
							<img src="../../../assets/service_center/homeImage/center_num.png">
							<!-- :id=`itemTop${index}` -->
							<p :id="`itemTop${index}`" class="main_top_middle_num_list5">0</p>
						</div>
					</div>
					<div class="main_top_middle_bottom">
						<div class="main_top_middle_bottom_echarts">
							<img src="../../../assets/service_center/homeImage/main_top_bottom.png">
							<div class="main_top_echarts_con">
								<div class="main_top_echarts_con_title">站号设备数量占比</div>
								<div id="threeTasksId" class="main_top_echarts_pie" _echarts_instance_="ec_1608257404246" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
									<div id="threeTasks_main" style="width: 100%; height: 100%;"></div>
								</div>
							</div>
						</div>
						<div class="main_top_middle_bottom_echarts main_top_middle_bottom_echarts_right">
							<img src="../../../assets/service_center/homeImage/main_top_bottom.png">
							<div class="main_top_echarts_con">
								<div class="main_top_echarts_con_title">区域设备数量占比</div>
								<div id="publicityId" class="main_top_echarts_pie" _echarts_instance_="ec_1608257404245" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
									<div id="publicity_main" style="width: 100%; height: 100%;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main_top_left main_top_right">
					<div class="main_top_left_top">
						<img src="../../../assets/service_center/homeImage/main_top_left.png">
						<div class="main_top_left_top_title">告警统计</div>
						<div class="main_top_left_top_con">
							<div class="main_top_left_top_con_left" style="margin-top: 0px" v-on:click="popupClick('getAbTjDataList', 2, '今日告警数', '', 1)">
								<span id="itemImg8" class="daysData counter-value">0</span>
								<p>今日告警数</p>
							</div>
							<div class="main_top_left_top_con_right" style="margin-top: 0px" v-on:click="popupClick('getAbTjDataList', 2, '七日告警数', '', 2)">
								<span id="itemImg9" class="weekData counter-value">0</span>
								<p>七日告警数</p>
							</div>
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTjDataList', 2, '本月告警数', '', 3)">
								<span id="itemImg10" class="monthData counter-value">0</span>
								<p>本月告警数</p>
							</div>
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTjDataList', 2, '本季告警数', '', 4)">
								<span id="itemImg11" class="someThing counter-value">0</span>
								<p>本季告警数</p>
							</div>
							<div class="main_top_left_top_con_list" v-on:click="popupClick('getAbTjDataList', 2, '本年告警数', '', 5)">
								<span id="itemImg12" class="policyData counter-value">0</span>
								<p>本年告警数</p>
							</div>
						</div>
					</div>
					<div class="main_top_left_top main_top_left_bottom">
						<img src="../../../assets/service_center/homeImage/main_top_left.png">
						<div class="main_top_left_top_title">设备在线离线占比</div>
						<div id="questionId" class="main_top_left_top_con" _echarts_instance_="ec_1608257404244" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
							<div id="question_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="main_middle">
				<div class="main_middle_list" v-for="(item, index) in DeviceGjTopLists" :key="item.DeviceCode" v-on:click="popupClick('getAbTypeDataList', 2, (item.DeviceName ? item.DeviceName : '--'), item.DeviceCode)">
					<img src="../../../assets/service_center/homeImage/main_middle.png">
					<div class="main_list_title main_list_title1">{{item.DeviceName ? item.DeviceName : '--'}}</div>
					<!-- :id=`deviceTop${index}` -->
					<span :id="`deviceTop${index}`" class="main_list_title_num main_list_title_num1 counter-value">0</span>
				</div>
			</div>
			<div class="main_bottom">
				<div class="main_bottom_top">
					<div class="main_bottom_top_list">
						<img src="../../../assets/service_center/homeImage/main_bottopm_top1.png">
						<div class="main_bottom_t_r_more" v-on:click="popupClick('getAbData', 2, '告警记录')">更多 ></div>
						<div class="main_bottom_t_l_title">告警记录</div>

						<div class="main_bottom_t_l_con">
							<div id="wrapper" class="main_bottom_t_l_main" style="visibility: visible; overflow: hidden; position: relative; z-index: 2; left: 0px; height: 100%">
								<ul id="content" style="margin: 0px; padding: 0px; position: relative; list-style-type: none; z-index: 1; top: 0px;">
									<li v-for="(item, index) in DeviceRealTimeGjLists" :key="index + '132'" style="overflow: hidden; float: none; width: 100%; height: 1.55vw;">
										<div class="main_bottom_t_l_main_list">
											<div class="main_bottom_t_list_title main_bottom_t_list_title2">{{item.DeviceName}}</div>
											<div class="main_bottom_t_list_title main_bottom_t_list_title2" style="color: #C23531">{{item.AbName}}</div>
											<div class="main_bottom_t_list_time main_bottom_t_list_time2">{{item.AbData | formDate}}</div>
										</div>
									</li>
								</ul>
								<ul v-if="DeviceRealTimeGjLists.length > 4" id="fakeContent" style="margin: 0px; padding: 0px; position: relative; list-style-type: none; z-index: 1; top: 0px;"></ul>
							</div>
						</div>
					</div>
					<div class="main_bottom_top_list">
						<img src="../../../assets/service_center/homeImage/main_bottopm_top2.png">
						<div class="main_bottom_t_l_title">告警占比</div>
						<div id="departmentId" class="main_bottom_t_l_chart" _echarts_instance_="ec_1608257404247" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
							<div id="department_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
					<div class="main_bottom_top_list">
						<img src="../../../assets/service_center/homeImage/main_bottopm_top1.png">
						<div class="main_bottom_t_r_more" v-on:click="popupClick('loadDateOperationRecord', 4, '操作日志')">更多 ></div>
						<div class="main_bottom_t_l_title">操作日志</div>
						<div class="main_bottom_t_l_con">
							<div id="wrapper2" class="main_bottom_t_l_main2" style="visibility: visible; overflow: hidden; position: relative; z-index: 2; left: 0px; height: 100%">
								<ul id="content2" style="margin: 0px; padding: 0px; position: relative; list-style-type: none; z-index: 1; top: 0px;">
									<li v-for="item in SystemOperationLists" :key="item.CreateDate" style="overflow: hidden; float: none; width: 100%; height: 1.55vw;">
										<div class="main_bottom_t_l_main_list">
											<div class="main_bottom_t_list_title main_bottom_polity_title2">{{item.DeviceCode}}</div>
											<div class="main_bottom_t_list_title main_bottom_polity_title2">{{item.OperationMessage}}</div>
											<div class="main_bottom_t_list_time main_bottom_polity_time1">{{item.CreateDate | formDate}}</div>
										</div>
									</li>
								</ul>
								<ul v-if="DeviceRealTimeGjLists.length > 4" id="fakeContent2" style="margin: 0px; padding: 0px; position: relative; list-style-type: none; z-index: 1; top: 0px;"></ul>
							</div>
						</div>
					</div>
				</div>
				<div class="main_bottom_bottom">
					<div class="main_bottom_b_left">
						<img src="../../../assets/service_center/homeImage/main_bottom_bottom.png">
						<div class="main_bottom_b_title">七日总能耗统计</div>
						<div id="coverageId" class="main_bottom_b_con" _echarts_instance_="ec_1608257404248" style="-webkit-tap-highlight-color: transparent; user-select: none;">
							<div id="coverage_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
					<div class="main_bottom_b_middle1">
						<img src="../../../assets/service_center/homeImage/main_bootm_middle.png">
						<div class="main_bottom_b_title">今日站号总能耗统计</div>
						<div id="contentId" class="main_bottom_b_con main_bottom_b_con2" _echarts_instance_="ec_1608257404250" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
							<div id="content_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
					<div class="main_bottom_b_middle2">
						<img src="../../../assets/service_center/homeImage/main_bootm_middle.png">
						<div class="main_bottom_b_title">今日能耗分时统计</div>
						<div id="publicNumId" class="main_bottom_b_con main_bottom_b_con2" _echarts_instance_="ec_1608257404251" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
							<div id="public_num_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
					<div class="main_bottom_b_right">
						<img src="../../../assets/service_center/homeImage/main_bottom_bottom.png">
						<div class="main_bottom_b_title">年度能耗统计</div>
						<div id="yearsNumId" class="main_bottom_b_con" _echarts_instance_="ec_1608257404249" style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">
							<div id="years_num_main" style="width: 100%; height: 100%;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="app-pupop-mode" v-if="popupState" v-on:click="shutDown('self')">
			<div class="app-pupop" v-on:click.stop="shutDown()">
				<dv-border-box-11 background-color="rgba(7,22,55, 0.7)" :title="popupTitle">

					<div class="outline-mode" v-if="popupStatus == 1">

						<div class="map-bottom-content-tab">
							<div class="map-bottom-content-tab-item1">设备编号</div>
							<div class="map-bottom-content-tab-item1">设备名称</div>
							<div class="map-bottom-content-tab-item1">异常现象</div>
							<div class="map-bottom-content-tab-item1">发生异常时间</div>
							<div class="map-bottom-content-tab-item1 tabHandle1">操作</div>
						</div>
						<div class="map-bottom-list">
							<div class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
								<div class="map-bottom-list-item1" v-for="item in LoadBjDeviceLists" :key="item.Id">
									<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
									<div class="map-bottom-list-item-addr">{{item.DeviceName}}</div>
									<div class="map-bottom-list-item-date">{{item.AbnormalName}}</div>
									<div class="map-bottom-list-item-date">{{item.UpdateTime | formDate}}</div>
									<div class="map-bottom-list-item-handle1">
										<div class="jc_device" v-on:click="JcAlarm(item)">
											解除报警
										</div>
									</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
						</div>
						<div class="user-top-list-page">
							<Page :total="totalCount" v-on:on-change="DeviceChange" v-on:on-page-size-change="DeviceSizeChange" size="small" show-total show-elevator show-sizer placement="top" />
						</div>
					</div>

					<div class="outline-mode" v-if="popupStatus == 2">

						<div class="map-bottom-content-tab">
							<div class="map-bottom-content-tab-item">设备编号</div>
							<div class="map-bottom-content-tab-item">异常码类别</div>
							<div class="map-bottom-content-tab-item">异常码名称</div>
							<div class="map-bottom-content-tab-item">发生异常时间</div>
							<div class="map-bottom-content-tab-item tabHandle">当前值</div>
							<div class="map-bottom-content-tab-item tabHandle">当前阈值</div>
							<div class="map-bottom-content-tab-item tabHandle">操作</div>
						</div>
						<div class="map-bottom-list">
							<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
								<div class="map-bottom-list-item" v-for="item in LoadBjDeviceLists" :key="item.Id">
									<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
									<div class="map-bottom-list-item-addr">{{item.ParameterName}}</div>
									<div class="map-bottom-list-item-date">{{item.AbnormalName}}</div>
									<div class="map-bottom-list-item-date">{{item.AbnormalDate | formDate}}</div>
									<div class="map-bottom-list-item-handle">{{item.CurrentValue}}</div>
									<div class="map-bottom-list-item-handle">{{item.RatedValue}}</div>
									<div class="map-bottom-list-item-handle">{{item.BalaceValue}}</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
						</div>
						<div class="user-top-list-page">
							<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange" v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer placement="top" />
						</div>
					</div>

					<div class="outline-mode" v-if="popupStatus == 3">

						<div class="map-bottom-content-tab">
							<div class="map-bottom-content-tab-item1">设备编号</div>
							<div class="map-bottom-content-tab-item1">设备名称</div>
							<div class="map-bottom-content-tab-item1">设备状态</div>
							<div class="map-bottom-content-tab-item1">设备地址</div>
							<div class="map-bottom-content-tab-item1 tabHandle1">通讯时间</div>
						</div>
						<div class="map-bottom-list">
							<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
								<div class="map-bottom-list-item1" v-for="item in LoadBjDeviceLists" :key="item.Id">
									<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
									<div class="map-bottom-list-item-addr">{{item.DeviceName}}</div>
									<div class="map-bottom-list-item-date">{{item.DeviceStatus == 1 ? '在线' : '离线'}}</div>
									<div class="map-bottom-list-item-date">{{item.Address}}</div>
									<div class="map-bottom-list-item-handle1">{{item.UpdateTime | formDate}}</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
						</div>
						<div class="user-top-list-page">
							<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange" v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer placement="top" />
						</div>
					</div>

					<div class="outline-mode" v-if="popupStatus == 4">

						<div class="map-bottom-content-tab">
							<div class="map-bottom-content-tab-item2">操作账号</div>
							<div class="map-bottom-content-tab-item2">设备编号</div>
							<div class="map-bottom-content-tab-item2">操作信息</div>
							<!-- <div class="map-bottom-content-tab-item1">设备地址</div> -->
							<div class="map-bottom-content-tab-item2">操作时间</div>
						</div>
						<div class="map-bottom-list">
							<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
								<div class="map-bottom-list-item2" v-for="item in LoadBjDeviceLists" :key="item.Id">
									<div class="map-bottom-list-item-device">{{item.LoginCode}}</div>
									<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
									<div class="map-bottom-list-item-date">{{item.OperationContent}}</div>
									<!-- <div class="map-bottom-list-item-date">{{item.Address}}</div> -->
									<div class="map-bottom-list-item-date">{{item.CreateDate | formDate}}</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无数据</div>
						</div>
						<div class="user-top-list-page">
							<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange" v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer placement="top" />
						</div>
					</div>

					<div class="outline-mode" v-if="popupStatus == 5">

						<div class="map-bottom-content-tab">
							<div class="map-bottom-content-tab-item2">设备编号</div>
							<div class="map-bottom-content-tab-item2">设备名称</div>
							<div class="map-bottom-content-tab-item2">能耗</div>
							<div class="map-bottom-content-tab-item2">统计时间</div>
						</div>
						<div class="map-bottom-list">
							<div id="content" class="map-bottom-lists" v-if="LoadBjDeviceLists.length > 0">
								<div class="map-bottom-list-item2" v-for="item in LoadBjDeviceLists" :key="item.Id">
									<div class="map-bottom-list-item-device">{{item.DeviceCode}}</div>
									<div class="map-bottom-list-item-addr">{{item.DeviceName}}</div>
									<div class="map-bottom-list-item-date">{{item.Etotal}}</div>
									<div class="map-bottom-list-item-date">{{item.CreateDate | formDate}}</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-if="LoadBjDeviceLists.length == 0">暂无能耗</div>
						</div>
						<div class="user-top-list-page">
							<Page :total="totalCount" :styles="styles" size="small" v-on:on-change="DeviceChange" v-on:on-page-size-change="DeviceSizeChange" show-total show-elevator show-sizer placement="top" />
						</div>

					</div>

				</dv-border-box-11>
			</div>
		</div>
	</div>
</template>

<script>
	import Echarts from 'echarts'
	import Cookies from 'js-cookie'
	import $ from 'jquery'
	import api from '../../../api/ros_request.js'
	export default {
		data() {
			return {
				DeviceGjCounts: {},
				DeviceGjTopLists: [],

				DeviceTypeZb: [], // 设备类型占比
				DeviceZhZb: [], // 设备站号占比
				DeviceQyZb: [], // 设备区域占比

				GetTodayNhByZhZbLists: [], // 今日设备能耗与站号占比

				DeviceRealTimeGjLists: [], // 实时告警列表

				SystemOperationLists: [], // 操作日志列表

				numCounts: [],

				LoadBjDeviceLists: [], // 异常列表

				DeviceCode: '',
				popupState: false,
				popupTitle: '',
				popupType: '',
				popupStatus: 0,
				TypeName: '',
				typeState: 0, // 1设备类型 2设备站号 3,设备区域 4,设备在线离线状态
				styles: {
					color: '#fff'
				},
				pageIndex: 1,
				pageSize: 10,
				totalCount: 0,
				TitleName: '',
				
				// 定时器
				t: null,
				timer: null,
				GetDeviceGjCountTime: null,
				GetDeviceGjTopTime: null,
			}
		},

		computed: {

		},

		mounted() {
			let _this = this;

			// 获取设备数量及告警数量
			_this.GetDeviceGjCount();

			this.GetDeviceGjCountTime = setInterval(() => {
				// 获取设备数量及告警数量
				_this.GetDeviceGjCount();
			}, 17500);

			// 设备信息占比统计
			_this.GetDeviceMesType();

			// 获取告警前五条数据
			_this.GetDeviceGjTop();

			this.GetDeviceGjTopTime = setInterval(() => {
				// 获取告警前五条数据
				_this.GetDeviceGjTop();
			}, 14000);

			// 告警占比
			_this.GetAbTypeZb();

			// 7日总能耗占比
			_this.GetZongNhTop();

			// 今日设备能耗与站号占比
			_this.GetTodayNhByZhZb();

			// 今日能耗分时统计
			_this.ConsoleElectricDetail();

			// 本年能耗季度查询
			_this.GetThisYearNhData();

			// 实时告警数据
			_this.GetDeviceRealTimeGj();

			// 操作日志数据
			_this.GetSystemOperation();
		},

		methods: {
			// 获取设备数量及告警数量
			GetDeviceGjCount() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceGjCount',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.DeviceGjCounts = res.data.Data;

						_this.getNumScroll(_this.DeviceGjCounts)

						_this.DevicelineCount(_this.DeviceGjCounts.DeviceOnlineCount, _this.DeviceGjCounts.DeviceofflineCount);

						let AbnormalCount = res.data.Data.AbnormalCount.toString(),
							numCounts = [];

						if (AbnormalCount.length == 4) AbnormalCount = '0' + AbnormalCount;
						else if (AbnormalCount.length == 3) AbnormalCount = '00' + AbnormalCount;
						else if (AbnormalCount.length == 2) AbnormalCount = '000' + AbnormalCount;
						else if (AbnormalCount.length == 1) AbnormalCount = '0000' + AbnormalCount;
						else if (AbnormalCount.length == 0) AbnormalCount = '00000' + AbnormalCount;

						for (var i = 0; i < AbnormalCount.length; i++) {
							numCounts.push(AbnormalCount.charAt(i))
						}

						_this.numCounts = numCounts;

						_this.$nextTick(function() {
							_this.numCounts.forEach((item, index) => {
								_this.numScroll(`itemTop${index}`, item);
							})
						});
					}
				}).catch(function(err) {

				});
			},
			// 刷新翻牌器
			getNumScroll(DeviceGjCounts) {
				let _this = this;
				_this.numScroll('itemImg1', DeviceGjCounts.GlAbnormalCount);
				_this.numScroll('itemImg2', DeviceGjCounts.GyAbnormalCount);
				_this.numScroll('itemImg3', DeviceGjCounts.QianyaCount);
				_this.numScroll('itemImg4', DeviceGjCounts.WenduCount);
				_this.numScroll('itemImg5', DeviceGjCounts.LdAbnormalCount);
				_this.numScroll('itemImg6', DeviceGjCounts.SanXiangBphcount);
				_this.numScroll('itemImg7', DeviceGjCounts.WeihuCount);
				_this.numScroll('itemImg8', DeviceGjCounts.TodayGjCount);
				_this.numScroll('itemImg9', DeviceGjCounts.WeekGjCount);
				_this.numScroll('itemImg10', DeviceGjCounts.MonGjCount);
				_this.numScroll('itemImg11', DeviceGjCounts.SeasonGjCount);
				_this.numScroll('itemImg12', DeviceGjCounts.YearGjCount);
			},
			
			// 设备信息占比统计
			GetDeviceMesType() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceMesType',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {

						// 设备类型占比
						_this.DeviceTypeZb = res.data.Data.DeviceTypeZb;
						_this.DeviceTypeZbEchartsData(_this.DeviceTypeZb);

						// 设备区域
						_this.DeviceQyZb = res.data.Data.DeviceQyZb;
						_this.DeviceQyZbEchartsData(_this.DeviceQyZb);

						// 设备站号占比
						_this.DeviceZhZb = res.data.Data.DeviceZhZb;
						_this.DeviceZHZbEchartsData(_this.DeviceZhZb);

					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 获取告警前五条数据
			GetDeviceGjTop() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceGjTop',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.DeviceGjTopLists = res.data.Data;
						_this.$nextTick(function () {
							_this.DeviceGjTopLists.forEach((item, index) => {
								_this.numScroll(`deviceTop${index}`, item.Count);
							})
						});
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 告警占比
			GetAbTypeZb() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbTypeZb',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.GetAbTypeZbEchartsData(res.data.Data);
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 7日总能耗占比
			GetZongNhTop() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetZongNhTop',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.ZongNhTopEchartsData(res.data.Data);
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 今日设备能耗与站号占比
			GetTodayNhByZhZb() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetTodayNhByZhZb',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.GetTodayNhByZhZbLists = res.data.Data;
						_this.TodayNhByZhZbEchartsData(_this.GetTodayNhByZhZbLists);
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 今日能耗分时统计
			ConsoleElectricDetail() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/ElectricTimeStatistics',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.ElectricDetailEchartsData(res.data.Data);
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 本年能耗季度查询
			GetThisYearNhData() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetThisYearNhData',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.ThisYearNhEchartsData(res.data.Data);
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 实时告警数据
			GetDeviceRealTimeGj() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceRealTimeGj',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.DeviceRealTimeGjLists = res.data.Data;
						_this.$nextTick(function () {
							_this.Carousel();
						});
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
			
			// 操作日志数据
			GetSystemOperation() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetSystemOperation',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin')
					},
				}).then(function(res) {
					if (res.data.Success) {
						_this.SystemOperationLists = res.data.Data;
						_this.$nextTick(function () {
							_this.Carousel2();
						});
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},
										
			/*================================================== 图表 ==========================================================*/
			/**
			 * 设备类型占比
			 * @@param data
			 */
			DeviceTypeZbEchartsData(data) {

				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.name);
					series.push(item.count);
				})

				_this.$nextTick(function () {
					_this.DeviceTypeZbOption(yAxis_data, series);
				});
			},
			DeviceTypeZbOption(yAxis_data, series) {
				let myChart = Echarts.init(document.getElementById('main'));
				let _this = this;
				let option = {
					grid: {
						left: '5%',
						top: '5%',
						right: '5%',
						bottom: '-15%',
						containLabel: true
					},
					yAxis: [{
						data: yAxis_data,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ccc',  //更改坐标轴文字颜色
								fontSize: 8      //更改坐标轴文字大小
							}
						},
						axisLine: {
							show: false
						},
						axisTick: {       //y轴刻度线
							show: false
						},
					}, {
						data: series,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#43eec6',  //更改坐标轴文字颜色
								fontSize: 8      //更改坐标轴文字大小
							}
						},
						axisLine: {
							show: false
						},
						axisTick: {       //y轴刻度线
							show: false
						},
					}],
					xAxis: {
						splitLine: { show: false },
						show: false,
						axisLine: {
							lineStyle: {
								color: '#ccc'
							},
							show: false
						},

					},
					series: [{
						name: 'bar',
						type: 'bar',
						barWidth: 5,
						itemStyle: {
							barBorderRadius: 2.5,
							color: new Echarts.graphic.LinearGradient(
								0, 0, 0, 1,
								[
									{ offset: 0, color: '#14c8d4' },
									{ offset: 1, color: '#43eec6' }
								]
							)
						},
						data: series
					}]
				};
				myChart.setOption(option);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getDeviceTypeList', 3, param.name, '', 1);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option, true);
				}, 15000);

			},
			
			/**
			 * 设备区域占比
			 * @@param data
			 */
			DeviceQyZbEchartsData(data) {
				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.name);
					series.push({
						name: item.name,
						value: item.count
					});
				})

				_this.$nextTick(function () {
					_this.DeviceQyZbOption(yAxis_data, series);
				});
			},
			DeviceQyZbOption(yAxis_data, series) {
				let myChart = Echarts.init(document.getElementById('publicity_main'));
				let _this = this;
				let option2 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						data: yAxis_data,
						top: 'center',
						right: '16%',
						bottom: 20,
						textStyle: {
							color: '#ffffff',
							fontSize: 8
						},
						itemWidth: 13,
						itemHeight: 13,
					},
					series: [
						{
							name: '设备区域',
							type: 'pie',
							radius: ['65%', '85%'],
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center'
							},
							center: ['20%', '50%'],
							data: series
						}
					]
				};
				myChart.setOption(option2);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getDeviceTypeList', 3, param.name, '', 3);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option2, true);
				}, 15000);
			},
			/**
			 * 设备站号占比
			 * @@param data
			 */
			DeviceZHZbEchartsData(data) {
				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.name);
					series.push({
						name: item.name,
						value: item.count
					});
				})

				_this.$nextTick(function () {
					_this.DeviceZHZbOption(yAxis_data, series);
				});
			},
			DeviceZHZbOption(yAxis_data, series) {
				let myChart = Echarts.init(document.getElementById('threeTasks_main'));
				let _this = this;
				let option1 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						top: 'center',
						data: yAxis_data,
						orient: 'vertical',
						//这里写a
						formatter: ["{a|{name}}"].join("\n"),
						right: 0,
						bottom: 20,
						textStyle: {
							color: '#ffffff',
							rich: {
								//这里定义a的样式
								a: {
									width: 55,
									fontSize: 8,
								}
							}
						},
						itemWidth: 13,
						itemHeight: 13,
					},
					series: [
						{
							name: '站号占比',
							type: 'pie',
							radius: ['60%', '85%'],
							center: ['15%', '50%'],
							roseType: 'radius',
							label: {
								show: false
							},
							data: series
						}
					]
				};
				myChart.setOption(option1);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getDeviceTypeList', 3, param.name, '', 2);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option1, true);
				}, 15000);
			},			
			/**
			 * 在线离线占比
			 * @@param DeviceOnlineCount
			 * @@param DeviceofflineCount
			 */
			DevicelineCount(DeviceOnlineCount, DeviceofflineCount) {
				let _this = this,
					yAxis_data = ['在线', '离线'],
					series = [{ value: DeviceOnlineCount, name: '在线' },
					{ value: DeviceofflineCount, name: '离线' }];

				_this.$nextTick(function () {
					_this.DevicelineCountOption(yAxis_data, series);
				});
			},
			DevicelineCountOption(yAxis_data, series) {
				let _this = this;

				let myChart = Echarts.init(document.getElementById('question_main'));
				myChart.clear();

				let option3 = {
					color: ['#19CA88', '#858FF8'],
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					series: [
						{
							name: '设备状态',
							type: 'pie',
							radius: '80%',
							center: ['50%', '50%'],
							startAngle: 90,
							minAngle: 85,
							data: series
						}
					]
				};

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getDeviceTypeList', 3, param.name, '', 4);
				});

				myChart.setOption(option3, true);
			},
			/**
			 * 告警占比
			 * @@param data
			 */
			GetAbTypeZbEchartsData(data) {
				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.name);
					series.push({
						name: item.name,
						value: item.value
					});
				})

				_this.$nextTick(function () {
					_this.GetAbTypeZbOption(yAxis_data, series);
				});
			},
			GetAbTypeZbOption(yAxis_data, series) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('department_main'));
				let option4 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						left: 10,
						top: 50,
						data: yAxis_data,
						textStyle: {
							color: '#ffffff',
							fontSize: 10
						},
						itemWidth: 13,
						itemHeight: 13,
					},
					series: [
						{
							name: '告警占比',
							type: 'pie',
							center: ['75%', '60%'],
							radius: ['50%', '70%'],
							data: series
						}
					]
				};
				myChart.setOption(option4);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('loadDeviceAbList', 2, param.name);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option4, true);
				}, 15000);
			},
			/**
			 * 七日总能耗占比
			 * @@param data
			 */
			ZongNhTopEchartsData(data) {
				let _this = this, yAxis_data = [], series = [];

				let tpmeData = [...data];


				let max = _this.tpmeDataArray(tpmeData)[0].Etotal;

				if (max == 0) {
					data.forEach((item, index) => {
						yAxis_data.push({
							text: item.StationName + '日',
							max: max
						});
						series.push(item.Etotal);
					})
				} else {
					data.forEach((item, index) => {
						yAxis_data.push({
							text: item.StationName + '日',
							max: max,
							min: max - max * 2
						});
						series.push(item.Etotal);
					})
				}


				_this.$nextTick(function () {
					_this.ZongNhTopOption(yAxis_data, series);
				});
			},
			ZongNhTopOption(yAxis_data, series) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('coverage_main'));
				let option5 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						//雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
						confine: true,
						enterable: true, //鼠标是否可以移动到tooltip区域内
					},
					radar: [
						{

						},
						{
							indicator: yAxis_data,
							center: ['50%', '51%'],
							radius: '70%',
							splitArea: {
								show: true,
								areaStyle: {
									color: ['rgba(255,255,255,0)']  // 图表背景网格的颜色
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									width: 0.5,
									color: 'rgba(255,255,255,0.5)' // 图表背景网格线的颜色
								}
							},
							axisLabel: {           // 坐标轴文本标签，详见axis.axisLabel
								showMaxLabel: true,
								textStyle: {
									width: 0.5,
									color: 'rgba(255,255,255,0.5)' // 坐标轴刻度文字的样式
								}
							},
						}
					],
					series: [
						{
							name: '总能耗',
							type: 'radar',
							radarIndex: 1,
							data: [
								{
									value: series,
									areaStyle: {
										opacity: 0.8,
										color: new Echarts.graphic.RadialGradient(0.5, 0.5, 1, [
											{
												color: '#37D2D4',
												offset: 0
											},
											{
												color: '#37D2D4',
												offset: 1
											}
										])
									}
								}
							]
						}
					]
				}
				myChart.setOption(option5);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getNhDetail', 5, '七日总能耗统计');
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option5, true);
				}, 15000);
			},
			/**
			 * 今日设备能耗与站号占比
			 * @@param data
			 */
			TodayNhByZhZbEchartsData(data) {
				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					if (item.StationName.length > 4) {
						//yAxis_data.push(item.StationName.slice(0,4) + '...');
						yAxis_data.push(item.StationName);
					} else {
						yAxis_data.push(item.StationName);
					}

					series.push(item.Etotal);
				})

				_this.$nextTick(function () {
					_this.TodayNhByZhZbOption(yAxis_data, series);
				});
			},
			TodayNhByZhZbOption(yAxis_data, series) {

				let _this = this;
				let myChart = Echarts.init(document.getElementById('content_main'));
				let option6 = {
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c}'
					},
					grid: {
						left: '2%',
						top: '5%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					//dataZoom: {
					//	type: 'inside',
					//	start: 80,
					//	end: 100
					//},
					xAxis: {
						type: 'category',
						data: yAxis_data,
						axisLine: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ccc',
								fontSize: 10
							},
						},
						axisTick: {       //y轴刻度线
							show: false
						},
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ccc',
								fontSize: 10
							},
						},
						splitLine: {
							lineStyle: {
								color: "rgba(255,255,255,0.2)"
							}
						},
						axisTick: {
							show: false
						},
					},
					series: [{
						data: series,
						barMaxWidth: 30,
						itemStyle: {
							normal: {
								//这里是重点
								color: "#37D2D4"
							}
						},
						type: 'bar'
					}]
				};
				myChart.setOption(option6);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getNhYuZhDetail', 5, param.name);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option6, true);
				}, 15000);

			},
			/**
			 * 今日能耗时分统计
			 * @@param data
			 */
			ElectricDetailEchartsData(data) {

				let _this = this, yAxis_data = [], series = [];
				data.forEach((item, index) => {
					yAxis_data.push(item.sfm);
					series.push(item.Etotal);
				})

				_this.$nextTick(function () {
					_this.ElectricDetailOption(yAxis_data, series);
				});

			},
			ElectricDetailOption(yAxis_data, series) {
				let _this = this;
				let myChart = Echarts.init(document.getElementById('public_num_main'));
				let option7 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						trigger: 'axis',
					},
					grid: {
						left: '2%',
						top: '5%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							boundaryGap: false,
							data: yAxis_data,
							axisLine: {
								show: false
							},
							axisLabel: {
								show: true,
								textStyle: {
									color: '#ccc',
									fontSize: 10
								},
							},
							axisTick: {       //y轴刻度线
								show: false
							},
						}
					],
					yAxis: [
						{
							type: 'value',
							axisLine: {
								show: false,
							},
							axisLabel: {
								show: true,
								textStyle: {
									color: '#ccc',
									fontSize: 10
								},
							},
							splitLine: {
								lineStyle: {
									color: "rgba(255,255,255,0.2)"
								}
							},
							axisTick: {
								show: false
							},
						}
					],
					series: [
						{
							name: '能耗',
							type: 'line',
							smooth: true,
							stack: '总量',
							areaStyle: {},
							data: series,
							itemStyle: {
								normal: {   //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
									color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0, color: 'rgba(55,210,212,0.3)' // 0% 处的颜色
									}, {
										offset: 0.5, color: 'rgba(55,210,212,0.1)'
									}, {
										offset: 1, color: 'rgba(55,210,212,0.0)' // 100% 处的颜色
									}]
									),  //背景渐变色
									lineStyle: {        // 系列级个性化折线样式
										color: 'rgba(55,210,212,1)'
									}
								},
								emphasis: {
									color: 'rgba(55,210,212,1)'
								}
							},//线条样式

						}
					]
				};
				myChart.setOption(option7);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getNhFenshiData', 5, param.name);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option7, true);
				}, 15000);
			},
			
			/**
			 * 年度能耗统计
			 * @@param data
			 */
			ThisYearNhEchartsData(data) {
				let _this = this, yAxis_data = [];
				yAxis_data = ['第一季度', '第二季度', '第三季度', '第四季度'];
				let series1 = [parseInt(data[0].Etotal), parseInt(data[3].Etotal), parseInt(data[6].Etotal), parseInt(data[9].Etotal)];
				let series2 = [parseInt(data[1].Etotal), parseInt(data[4].Etotal), parseInt(data[7].Etotal), parseInt(data[10].Etotal)];
				let series3 = [parseInt(data[2].Etotal), parseInt(data[5].Etotal), parseInt(data[8].Etotal), parseInt(data[11].Etotal)];
				_this.$nextTick(function () {
					_this.ThisYearNhOption(yAxis_data, series1, series2, series3);
				});

			},
			ThisYearNhOption(yAxis_data, series1, series2, series3) {
				let myChart = Echarts.init(document.getElementById('years_num_main'));
				let _this = this;
				let option8 = {
					color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {            // 坐标轴指示器，坐标轴触发有效
							type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '2%',
						top: '5%',
						right: '2%',
						bottom: '0%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						show: false,
						axisLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ccc',
								fontSize: 10
							},
						},
						splitLine: { show: false },
						axisTick: {
							show: false
						},
					},
					yAxis: {
						type: 'category',
						data: yAxis_data,
						axisLine: {
							show: false,
						},
						splitLine: { show: false },
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ccc',
								fontSize: 10
							},
						},
						axisTick: {
							show: false
						},
					},
					series: [
						{
							type: 'bar',
							stack: '总量',
							name: '第一个月',
							barWidth: 10,
							barMinHeight: 40,
							barMaxHeight: 100,
							data: series1
						},
						{
							type: 'bar',
							stack: '总量',
							name: '第二个月',
							barMinHeight: 40,
							barMaxHeight: 100,
							data: series2
						},
						{
							type: 'bar',
							stack: '总量',
							name: '第三个月',
							barMinHeight: 40,
							barMaxHeight: 100,
							data: series3
						}
					]
				};
				myChart.setOption(option8);

				window.addEventListener('resize', function () {
					myChart.resize()
				})

				myChart.on('click', function (param) {
					_this.popupClick('getYearNhDetail', 5, param.name);
				});

				setInterval(() => {
					myChart.clear();
					myChart.setOption(option8, true);
				}, 15000);
			},
			
			// 弹窗
			popupClick(type, status, name = '', deviceCode = '', typeState = 0) {
				let _this = this;
				_this.popupState = true;
				_this.pageIndex = 1;
				_this.pageSize = 10;
				_this.popupStatus = status;
				_this.popupType = type;
				_this.popupTitle = name;

				_this.totalCount = 0;
				_this.LoadBjDeviceLists = [];
				
				if (type == 'abnormal') _this.Abnormal();
				else if (type == 'loadDeviceAbList') {
					if (name == '温度异常') {
						_this.TypeName = name.slice(0, 1);
					} else {
						_this.TypeName = name.slice(0, 2);
					}
					_this.LoadDeviceAbList();
				} else if (type == 'getAbTypeDataList') {
					if (deviceCode) {
						_this.DeviceCode = deviceCode;
						_this.TypeName = '';
					} else if (name) {
						_this.DeviceCode = '';
						if (name == '温度异常') {
							_this.TypeName = name.slice(0, 1);
						} else if (name == '三相不平衡') {
							_this.TypeName = name.slice(2, 5);
						} else {
							_this.TypeName = name.slice(0, 2);
						}
					} else {
						_this.popupTitle = '全部告警';
					}
					_this.GetAbTypeDataList();
				} else if (type == 'getDeviceTypeList') {
					_this.typeState = typeState;
					_this.GetDeviceTypeList();
				} else if (type == 'getAbData') _this.GetAbData();
				else if (type == 'loadDateOperationRecord') _this.LoadDateOperationRecord();
				else if (type == 'getAbTjDataList') {
					_this.typeState = typeState;
					_this.GetAbTjDataList();
				} else if (type == 'getNhDetail') _this.GetNhDetail();
				else if (type == 'getNhYuZhDetail') _this.GetNhYuZhDetail();
				else if (type == 'getNhFenshiData') _this.GetNhFenshiData();
				else if (type == 'getYearNhDetail') _this.GetYearNhDetail();

			},
			
			// 获取异常告警
			Abnormal() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbDeviceList',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize
					},
				}).then(function(res) {
					if (res.data.code == 0) {
						_this.LoadBjDeviceLists = res.data.Data;
						_this.totalCount = res.data.TotalCount;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// // 解除报警
			// JcAlarm(item) {
			// 	let _this = this;
			// 	axios
			// 		.post('/Home/JcAlarm?DeviceCode=' + item.DeviceCode + '&Id=' + item.Id + '&Remarks=' + item.Remarks)
			// 		.then(res => {
			// 			if (res.data.Code == 0) {
			// 				_this.Abnormal();
			// 				if (count == 0) {
			// 					StopSound();
			// 				} else {
			// 					PlaySound();
			// 				}
			// 			}
			// 		})
			// 		.catch(err => { // 请求失败处理
			// 			console.log(err);
			// 		});
			// },
			// LoadDeviceAbList
			LoadDeviceAbList() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbTypeDataList',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.TypeName
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});

			},

			// GetAbTypeDataList
			GetAbTypeDataList() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbTypeDataList',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						DeviceCode: _this.DeviceCode,
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.TypeName
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// GetDeviceTypeList 
			GetDeviceTypeList() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceTypeList',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.typeState,
						DeType: _this.popupTitle
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// GetAbData
			GetAbData() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbData',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// LoadDateOperationRecord
			LoadDateOperationRecord() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/LoadDateOperationRecord',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// GetAbTjDataList
			GetAbTjDataList() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetAbTjDataList',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.typeState
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// 7日能耗详情
			GetNhDetail() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetDeviceNhDrData',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// 能耗与站号详情
			GetNhYuZhDetail() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetNhYuZhDetail',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.popupTitle
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// 获取能耗分时数据
			GetNhFenshiData() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetNhFenshiData',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: _this.popupTitle
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			// 年度能耗详情
			GetYearNhDetail() {
				let _this = this;
				let type = _this.popupTitle == '第一季度' ? '1' : _this.popupTitle == '第二季度' ? '2' : _this.popupTitle == '第三季度' ? '3' : '4';
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: 'ShowData/Device/GetYearNhDetail',
					data: {
						CompanyCode: Cookies.get('ros_CompanyCode'),
						DepartmentCode: Cookies.get('ros_DepartmentCode'),
						GroupCode: Cookies.get('ros_GroupCode'),
						isAdmin: Cookies.get('ros_isAdmin'),
						pageIndex: _this.pageIndex,
						pageSize: _this.pageSize,
						DataType: type
					},
				}).then(function(res) {
					if (res.data.Code == 0) {
						_this.totalCount = res.data.TotalCount;
						_this.LoadBjDeviceLists = res.data.Data;
					}
				})
				.catch(err => { // 请求失败处理
					console.log(err);
				});
			},

			DeviceChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.ReloadFunt();
			},
			DeviceSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.ReloadFunt();
			},

			ReloadFunt() {
				let _this = this;
				switch (_this.popupType) {
					case 'abnormal':
						_this.Abnormal();
						break;
					case 'loadDeviceAbList':
						_this.LoadDeviceAbList();
						break;
					case 'getAbTypeDataList':
						_this.GetAbTypeDataList();
						break;
					case 'getDeviceTypeList':
						_this.GetDeviceTypeList();
						break;
					case 'getAbData':
						_this.GetAbData();
						break;
					case 'loadDateOperationRecord':
						_this.LoadDateOperationRecord();
						break;
					case 'getAbTjDataList':
						_this.GetAbTjDataList();
						break;
					case 'getNhDetail':
						_this.GetNhDetail();
						break;
					case 'getNhYuZhDetail':
						_this.GetNhYuZhDetail();
						break;
					case 'getNhFenshiData':
						_this.GetNhFenshiData();
						break;
					case 'getYearNhDetail':
						_this.GetYearNhDetail();
						break;
				}
			},
			
			// 排序
			tpmeDataArray(tpmeData) {

				for (var i = 0; i < tpmeData.length - 1; i++) {
					for (var j = 0; j < tpmeData.length - i - 1; j++) {
						if (tpmeData[j].Etotal < tpmeData[j + 1].Etotal) {
							let tpme = {};
							tpme = tpmeData[j];
							tpmeData[j] = tpmeData[j + 1];
							tpmeData[j + 1] = tpme;
						}
					}
				}
				return tpmeData;

			},

			// 关闭弹窗
			shutDown(type) {
				if (type == 'self') {
					let _this = this;
					_this.popupState = false;
				}
			},

			// 数字翻牌器
			numScroll(id, maxNum, time = 1000) {
				var numDom = document.getElementById(id)
				var numInit = 0
				var addNum = maxNum / (time / 10)
				var minTime = time / maxNum
				var t = setInterval(function () {
					if (numInit >= maxNum) {
						clearInterval(t)
						t = null;
						if (numDom) {
							numDom.innerText = maxNum;
						}						
					} else {
						numInit += addNum
						if (numDom) {
							numDom.innerText = Math.round(numInit);
						}						
					}
				}, 10)
			},

			// 轮播
			Carousel() {
				this.roll(50);
			},

			roll(t) {

				let content = document.getElementById("content");
				let fakeContent = document.getElementById("fakeContent");
				let wrapper = document.getElementById("wrapper");

				let _this = this;

				if (!content) {
					return;
				}

				$('#fakeContent').html($('#content').html());
			
				// 开始无滚动时设为0
				wrapper.scrollTop = 0;

				var timer = null;

				//鼠标事件绑定
				$('#wrapper').hover(function () {
					clearInterval(timer);
					timer = null
				}, function () {
					timer = setInterval(() => {
						_this.rollStart(wrapper, content)
					}, t);
				}).mouseout();

			},

			// 开始滚动函数
			rollStart(wrapper, content) {
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (wrapper.scrollTop >= content.scrollHeight) {
					wrapper.scrollTop = 0;
				} else {
					wrapper.scrollTop++;
				}
			},

			// 轮播2
			Carousel2() {
				this.roll2(50);
			},

			roll2(t) {

				let content = document.getElementById("content2");
				let fakeContent = document.getElementById("fakeContent2");
				let wrapper = document.getElementById("wrapper2");

				let _this = this;

				if (!content) {
					return;
				}

				$('#fakeContent2').html($('#content2').html());

				// 开始无滚动时设为0
				wrapper.scrollTop = 0;

				this.timer = null;

				//鼠标事件绑定
				$('#wrapper2').hover(function () {
					clearInterval(this.timer);
					this.timer = null
				}, function () {
					this.timer = setInterval(() => {
						_this.rollStart2(wrapper, content)
					}, t);
				}).mouseout();

			},

			// 开始滚动函数二
			rollStart2(wrapper, content) {
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (wrapper.scrollTop >= content.scrollHeight) {
					wrapper.scrollTop = 0;
				} else {
					wrapper.scrollTop++;
				}
			},
			
			// 返回
			logout() {
				let _this = this;
				// 清除
				Cookies.set('ros_CompanyCode', '');
				Cookies.set('ros_DepartmentCode', '');
				Cookies.set('ros_GroupCode', '');
				Cookies.set('ros_isAdmin', '');
				_this.$router.push({
					name: 'index'
				})
			},
		},
		filters: {
			formDate: function (dateForm) {
				if (!dateForm) {
					return "";
				} else {
					var dateee = new Date(dateForm).toJSON();
					var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
						/\.[\d]{3}Z/, '');
					return date;
				}
			}
		},
		beforeDestroy () {
			clearInterval(this.t);
			clearInterval(this.timer);
			clearInterval(this.GetDeviceGjCountTime);
			clearInterval(this.GetDeviceGjTopTime);
		},
	}
</script>

<style scoped>
	.user-top-list-page>>>.ivu-page-item,
	.user-top-list-page>>>.ivu-page-prev,
	.user-top-list-page>>>.ivu-page-next,
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		background-color: rgba(255, 255, 255, 0);
		min-width: 1.2vw;
		height: 1.2vw;
		line-height: 1.2vw;
		border-radius: 3px;
	}
	
	.user-top-list-page>>>.ivu-page-item>a,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		color: rgb(200, 200, 200);
		font-size: 0.6vw;
	}
	
	.user-top-list-page>>>.ivu-page-item-active a,
	.ivu-page-item-active:hover a {
		color: #2d8cf0;
	}
	
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		border: 0.05vw solid rgba(255, 255, 255, 0.2);
	}
	
	.user-top-list-page>>>.ivu-select-selected-value,
	.user-top-list-page>>>.ivu-page-options-elevator {
		color: rgba(255, 255, 255, 0.6);
	}
</style>
<style src="./ros_home.css" scoped></style>
